import React, { useState, useMemo } from 'react'
import { useScrollPosition } from '@n8tb1t/use-scroll-position'
import { Link } from 'gatsby'
import styled from 'styled-components'
import logo from '../../../img/logo_white.svg'
import { NavbarBottom } from './NavbarBottomStyles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../../../utils/fontawesome'

export default () => {
  const [hideOnScroll, setHideOnScroll] = useState(true)

  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y
      if (isShow !== hideOnScroll) setHideOnScroll(isShow)
    },
    [hideOnScroll],
    false,
    false,
    300
  )

  return useMemo(
    () => (
      <>
        <NavbarBottom show={hideOnScroll}>
          <NavbarBottomContent
            role='navigation'
            aria-label='bottom-navigation' style={{ boxShadow: '0 0 4px black', background: 'rgba(255,255,255,0.5)' }}
          >
            <Link to='/about'
              activeStyle={{ color: 'orange' }}
              partiallyActive={true}
              style={{ display: 'inline-block', width: '20%' }}
              className='navbar-item is-expanded has-text-centered'
              >
              <FontAwesomeIcon icon='users' className='navIcon' style={{ fontSize: '1rem' }} />
              <p className='is-size-7'>About</p>
            </Link>

            <Link to='/help'
              activeStyle={{ color: 'orange' }}
              partiallyActive={true}
              style={{ display: 'inline-block', width: '20%' }}
              className='navbar-item is-expanded has-text-centered'
            >
              <FontAwesomeIcon icon='question-circle' className='navIcon' style={{ fontSize: '1rem' }} />
              <p className='is-size-7'>Hilfe</p>
            </Link>

            <Link to='/' id='bottom-nav-icon-bg' style={{ display: 'inline-block', width: '20%', height: '100%' }} className='navbar-item is-expanded has-text-centered'>
              <img src={logo} alt='Logo' style={{ width: '100%', maxHeight: '2.5rem' }} />
            </Link>

            <Link
              to='/kontakt'
              activeStyle={{ color: 'orange' }}
              partiallyActive={true}
              className='navbar-item is-expanded has-text-centered'
              style={{ display: 'inline-block', width: '20%' }}
            >
              <FontAwesomeIcon icon='envelope' className='navIcon' style={{ fontSize: '1rem' }} />
              <p className='is-size-7'>Kontakt</p>
            </Link>

            <Link
              to='/#produkte'
              activeStyle={{ color: 'orange' }}
              partiallyActive={true}
              className='navbar-item is-expanded has-text-centered'
              style={{ display: 'inline-block', width: '20%' }}
            >
              <FontAwesomeIcon icon='shopping-cart' className='navIcon' style={{ fontSize: '1rem' }} />
              <p className='is-size-7'>Shoppen</p>
            </Link>
          </NavbarBottomContent>
        </NavbarBottom>
      </>
    ),
    [hideOnScroll]
  )
}

const NavbarBottomContent = styled.div`
  background: white;
`
